import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={18}
    height={30}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.002 27.318 2.684 30l15-15-15-15L.002 2.682 12.32 15 .002 27.318Z"
      fill="#666"
    />
  </svg>
);

export default SvgComponent;
